import React, { useContext } from 'react';
import { PageContext } from '../context';
import UserInfoHeader from '../../shared/UserInfoHeader';
import MyBookingsBody from './MyBookingsBody';
import PageLayout from '../../shared/PageLayout';

const MyBookingsPageContent = () => {
  const {
    contextData: {
      bookingsData: { firstName, lastName, profession },
    },
  } = useContext(PageContext);

  const morikawaImg = 'https://golfdigest.sports.sndimg.com/content/dam/images/golfdigest/fullset/2020/04/13/5e94b9f418447fde1f318495_200413-collin-morikawa.jpg.rend.hgtvcom.966.725.suffix/1587139337018.jpeg';

  return (
    <PageLayout isDark>
      <UserInfoHeader
        avatarImg={morikawaImg}
        firstName={firstName}
        lastName={lastName}
        description={profession}
      />
      <MyBookingsBody />
    </PageLayout>
  );
};

export default MyBookingsPageContent;
